import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Table cell representing Sale and Price
 *
 * @param {{}} props
 * @constructor
 */
const SalePriceCell = props => (
    <span>
        <span
            className={classNames(props.customCell.options.saleName)}
        >
            {props.rowData[props.customCell.options.saleName]}
        </span>
        <br className={classNames(props.customCell.options.breakClassName)} />
        <span
            className={classNames(props.customCell.options.salePrice)}
        >
            {props.rowData[props.customCell.options.salePrice]}
        </span>
    </span>
);

SalePriceCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default SalePriceCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/SalePriceCell.js